const ko = {
	// Register
	1: '사용자 로그인',
	2: '사용자 이름을 입력하세요',
	3: '사용자 이름은 무조건 알파벳으로 시작해야 되고 영문,숫자,언더라인으로 조합하여 5-10자리로 만들어야 됩니다.',
	4: '비밀번호을 입력하세요.',
	5: '비밀번호는 알파벳,숫자으로 조합되여 6-15자리로 만들어야 됩니다',
	6: '다시 비밀번호를 입력하세요.',
	7: '메일을 입력하세요.',
	8: '메일 주소는 무조건 무자부호를 포함해야 됩니다.',
	9: '메일@의 왼쪽은 머리글자를 제외하여 다른것은 알파벳,언더라인,숫자，콤마(.), 작대기(-)로 채워도 됩니다.',
	10: '메일@의 오른쪽에 무조건 콤마(.)가 있어야 됩니다.',
	11: '골뱅이(@)와 콤마(.)사이에 무조건 알파벳,언더라인,숫자로 시작해야 되고 머리글자를 제외하여 다른것은 알파벳,언더라인,숫자，콤마(.), 작대기(-)로 채워도 됩니다.',
	12: '남',
	13: '여',
	14: '인증번호를 입력하세요',
	15: '여기를 클릭하여 인증번호를 넣어주세요.',
	16: '아이디 생성 완료',
	17: '돌아가기',
	18: '여기를 클릭하고 메세지를 보내주세요',
	// Index
	19: '사랑하는 컨탱거라우스 탱크,동록하세요~',
	20: '등록하면 개인 정보를 확인 가능합니다~(실적,길드 및 재산 포함）',
	21: '공식 사이트에 개인정보는 ‘업데이트 미완료’로 나타나 있으면 게임 데이터를 기준으로 확인하시면 됩니다.',
	22: '회원 가입',
	23: '(게임 다운로드)클릭',
	24: '충전하기',
	25: '초보자 도우미',
	26: '고급 승급',
	27: '커뮤니티',
	28: '티어 등급',
	29: '전투 방법',
	30: '기대해보세요',
	31: '도구 소개',
	32: '지도 소개',
	33: '탱크 소개',
	34: '신문',
	35: '공지사항',
	36: '미디어 평가',
	37: '플레이어 공략',
	38: '인터넷 블로그 이슈 댓글',
	39: '추가적인 미디어 평가',
	40: '다른 것',
	// Apply
	41: '선택',
	42: '취소',
	43: '통과',
	44: '클랜이름',
	45: '클랜장',
	46: '신청자',
	47: '등급',
	48: '클랜 배치시간',
	49: '초대가 승인되었습니다.',
	50: '초대가 거부되었습니다.',
	51: '가입을 취소했습니다.',
	// Create
	52: '클랜을 만드세요( ',
	53: ' 한화충전',
	54: '당장 충전하세요',
	55: '로그아웃',
	56: '클랜이름은 3-12개 무자부호로 구성해야 됩니다',
	57: '컬러',
	58: '미리보기',
	59: '개설',
	60: '클랜 개설 시 기존 클랜 가입이 되어 있으면 탈퇴후 클랜개설이 가능합니다',
	61: '클랜을 성공적으로 개설했습니다',
	// Detail
	62: '클랜을 해제합니다',
	63: '클랜탈퇴했습니다.',
	64: '조작',
	65: '삭제',
	66: '명칭',
	67: '등급',
	68: '순위',
	69: '포인트 적립',
	70: '승률',
	71: '마지막 게임',
	72: '팀원을 삭제했습니다',
	73: '클랜해제 동의합니까?',
	74: '팁',
	75: '확인',
	76: '취소',
	77: '클랜을 성공적으로 해제했습니다',
	78: '취소했습니다',
	79: '클랜탈퇴 동의합니까?',
	80: '클랜탈퇴 성공했습니다',
	// Guild Index
	81: '선택',
	82: '가입',
	83: '명칭',
	84: '팀장',
	85: '팀원인수',
	86: '개설시간',
	87: '클랜 포인트 적립',
	88: '신청제출됐으니 팀장심의를 기다리세요!',
	// Recharge
	89: '충전',
	90: '충전방식',
	91: '충전금액',
	92: '한화를 ',
	93: '얻을수 있습니다',
	94: '포인트 적립 찬조 연락처',
	95: '충전 지지 성명',
	96: '존경그러운 여려분：',
	97: 'FortressTank는 FortressRed2에 마지막 성역으로 여러분이 같이 지지하고 지켜야합니다.저희는 게임중에 각종기능들 및 리페어후 잔여된 문제들을 업그레이드할 것입니다.',
	98: 'FortressTank를 운행할수 있도록 유지하기 위하여 아래 비용은 전수 무상으로 드릴거니참고하세요！',
	99: 'FortressTank를 사랑해주셔서 아주 감사합니다!',
	100: 'FortressTank 단체 2021.1.1',
	101: '충전중이니 조금만 기다려주세요~...',
	102: '닫기',
	103: 'Paypal충전',
	104: '알리페이 스캔으로 충전',
	105: 'QR코드로 충전',
	106: '충전 완료했습니다',
	// MotifyPassword
	107: '기존 비밀번호를 입력하세요',
	108: '새로운 비밀번호를 입력하세요',
	109: '비밀번호는 알파벳,숫자로만 6-15자리로 입력 가능합니다.',
	110: '비밀번호 다시 입력하세요',
	111: '변경',
	112: '메일을 입력하세요',
	113: '비밀번호 변경 완료됐습니다',
	// Login
	114: '사용자 등록',
	115: '등록',
	// SideBar
	116: '메인 화면',
	117: '클랜',
	118: '클랜 리스트',
	119: '클랜 상세정보',
	120: '클랜 개설',
	121: '신청 가입',
	122: '계정',
	123: '비밀번호을 입력하세요',
	124: '금액',
	125: '승리횟수',
	126: '패배횟수',
	127: '계정상태',
	// 
	128: '클릭 하여 다운로드 하 다.',
	129: '주의 하 다.',
	130: '반드시 설치 해 야 한다 C++ Runtime',
	131: '상단의 PayPal 버튼을 클릭해주세요.',
	132: '상품.',
	133: '포인트 적립',
	134: '친구를 위해 충전하다.',
	135: '친구의별명',
	136: '닉네임을 입력하십시오.',
	137: '닉네임을 1-6자리로 만들어야 됩니다',
	138: '닉네임을',
	139: '아이디변경',
	140: '닉네임 유형',
	141: '일반 아이디(300 한화충전)',
	142: '특문아이디 (1500 한화충전)',
	143: '닉네임 수정 완료.',
	144: '검사=',
	145: '등록되었습니다',
	146: '제목',
	147: '글쓴이',
	148: '비밀번호 찾기',
	149: '다음',
	150: '메시지 발송됨',
	151: '재설정할 비밀번호 입력',
	152: '검색',
	153: '아이디 찾기',
	154: '변경할 이메일 주소를 입력하세요',
	155: '변경할 이메일주소 한번 더 확인',
	156: '이메일 주소 두번 불일치',
	157: '이메일 주소 변경',
	158: '이메일 변경 완료됐습니다',
	159: '새 이메일 주소',
	160: '이메일',
	161: '길드 이름 변경',
	162: '길드 색상 변경',
	163: '길드 이름 변경 동의합니까',
	164: '길드 색상 변경 동의합니까',
	165: '길드 이름 변경  완료했습니다',
	166: '길드 색상 변경 완료했습니다',
	167: '양도',
	168: '길드마스터를 양도 하시겠습니까?',
	169: '길드마스터가 변경되었습니다.',
	170: '주문금액',
	171: '최소 충전금액 1,500 Cash 1,500 Cash 의 배수로만 충전 가능.ex) 1,500, 3,000, 4,500',
	172: '최소 충전금액 1,000 Score 1,000 Score 의 배수로만 충전 가능.ex) 100, 200, 300',
	173: '계정 성별 변경',
	174: '성별 변경이 완료되었습니다.',
	175: '로그인 아이디',
	176: '기존버젼',
	177: 'HD',
	178: '슈탱크',
	179: '매번 목욕의 불이 다시 살아나는 것은 모두 새로운 시작이고, 그 세월의 불길이 하늘을 찌르던 추억들을 다시 회복하는 것이다 …',
	180: '크기',
	181: '버전',
	182: '호환성',
	183: '소개하다',
	184: '게임 설치 패키지 다운로드 확인?',
	185: '바로 다운로드',
	186: '인증번호 받기',
	187: '인증번호를 입력해 주시기 바랍니다',
	188: '다음 단계',
	189: '인증번호 길이는 6',
	190: '로그인이 만료되었습니다. 다시 로그인해주세요.',
	191: '다른 곳에서 로그아웃되었습니다.',
	// Loading states
	192: '처리 중...',
	193: '로그인 중...',
	194: '인증 중...',
	195: '등록 중...',
	196: '생성 중...',
	// Validation messages
	197: '이메일을 입력해 주세요',
	198: '사용자 이름과 이메일을 입력해 주세요',
	199: '이메일과 인증코드를 입력해 주세요',
	200: '닉네임을 입력해 주세요',
	201: '모든 정보를 입력해 주세요',
	202: '비밀번호가 일치하지 않습니다',
	203: '전대 이름을 입력해 주세요',
	// Empty states
	205: '신청 내역이 없습니다',
	206: '구성원이 없습니다',
	207: '활성화됨',
	// Discord page
	208: '최신 게임 정보, 이벤트 공지 및 전 세계 플레이어들과 소통하려면 Discord 커뮤니티에 가입하세요!',
	209: '온라인 멤버',
	210: '게임 공지 채널',
	211: '플레이어 교류 채널',
	212: '주요 채널',
	213: '🎮 Discord 커뮤니티 가입',
	// Download page
	214: '공식 정품 | 보안 무결점 | 직접 설치 APK',
	215: 'App Store에서 "SuperTank"를 검색하여 다운로드 가능',
	216: 'Android 다운로드',
	217: 'iOS 다운로드',
	218: '휴대폰으로 QR코드를 스캔하여 다운로드하세요',
	// PC Index footer
	219: 'Lcent Computer Systems Co., Limited',
	// Login page
	220: '사용자 이름을 입력해 주세요',
	221: '비밀번호를 입력해 주세요',
	222: '← 홈으로 돌아가기',
	223: '여기를 클릭하여 APK 다운로드',
	224: '미리보기',
	225: '잔액 부족',
	226: '부족, 필요',
	227: '성별 변경에 필요한',
	// Download page game description
	228: 'SuperTank-강철 야수를 몰고 전세계를 지배한다!\n\n멋진 탱크, 자유로운 조립\n고전 전차에서 과학 기술 탱크에 이르기까지, 다양한 독특한 탱크 장갑 디자인을 선택할 수 있습니다! 화력, 장갑, 기동성의 자유로운 구성, 당신만의 슈퍼 탱크를 구축, 전장에서 적수가 날리는 곳마다!\n\n하드코어 조작, 기교 뽐내기\n정확한 조준과 유연한 위치 이동, 전술적 회피 ….매 경기는 기술과 전략의 마지막 시험대다! 단일 또는 팀 전투, 실력으로 상대를 라미네이트, 세계 랭킹에 등극!\n\n깊이 업그레이드, 전략이 왕\n대포에서 엔진에 이르기까지, 모든 부품을 강화할 수 있다! 각이한 스킬과 장비를 조합하여 독자 전술을 개발하고 무적 탱크 군단을 편성하여 모든 도전을 정복합니다!\n\n전 세계 실시간 대결\n전세계에서 온 게이머들과 겨뤄 당신의 슈퍼 탱크를 보여주세요! 여러 가지 모드는 당신을 통쾌하게 전투하게 합니다!\n\n즉시 다운로드하여 스틸 로정을 시작하십시오!\n슈퍼탱크의 세계에서 모든 포탄은 당신의 전설이 쓰여진다.- 지배자가 될 것인가, 총알받이가 될 것인가? 당신의 선택에 달렸어요!',
	// ErrorCode
	1000: '성공',
	1001: '실패',
	1002: '사용자 이름이 규칙에 맞지 않습니다',
	1003: '비밀번호가 규칙에 맞지 않습니다',
	1004: '이메일이 규칙에 맞지 않습니다',
	1005: '길드 미가입',
	1006: '신분증 규칙에 맞지 않습니다',
	1007: '아이디가 이미 존재합니다',
	1008: '아이디가 올바르지 않습니다',
	1009: '비밀번호가 올바르지 않습니다',
	1010: '계정 잠김',
	1011: '성별이 규칙에 맞지 않습니다',
	1012: '이미 가입한 길드가 있습니다',
	1013: '이미 신청한 길드가 있습니다',
	1014: '동훈장 이상이어야 길드를 개설할 수 있습니다',
	1015: '길드명이 이미 존재합니다',
	1016: '길드가 존재하지 않습니다',
	1017: '길드 미가입',
	1018: '리더만이 심사할 수 있습니다',
	1019: '이 길드의 구성원이 아니므로 목록을 볼 수 없습니다',
	1020: '길드 이름이 올바르지 않습니다',
	1021: '길드 가입신청서 없음',
	1022: '충전과정이 올바르지 않습니다.',
	1023: '금액이 정확하지 않습니다. 길드생성시 3000원이 필요합니다',
	1024: '초대코드가 잘못되었습니다',
	1025: '초대코드가 이미 사용되었습니다',
	1026: '길드 마스터는 삭제할 수 없습니다',
	1027: '알수없는오류',
	1028: '접근권한없음',
	1029: '닉네임이 올바르지 않습니다"',
	1030: '닉네임은 이미 존재합니다',
	1031: '닉네임이 규칙에 맞지 않습니다',
	1032: '금액이 맞지 않습니다',
	1033: '시작시간이 올바르지 않습니다',
	1034: '종료 시간이 잘못되었습니다',
	1035: '금액이 맞지 않습니다',
	1036: 'QR코드 형식이 잘못되었습니다',
	1037: 'QR코드가 올바르지 않습니다',
	1038: '인증번호가 잘못되었습니다.',
	1039: '이메일이 올바르지 않습니다.',
	1040: '암호 재설정 횟수를 초과했습니다.(1일1회)',
	1040: '일일 초기화 횟수 상한 초과',
	1041: '점수가 올바르지 않음',
	1042: '영수증이 올바르지 않음',
	1043: 'GiftType이 올바르지 않음',
	1044: '상품 수량이 올바르지 않음',
	1045: 'TerminalType이 올바르지 않음',
	1046: '결제 방식이 올바르지 않음',
	1047: 'Tier가 올바르지 않음',
	1048: 'SteamId가 올바르지 않음',
	1049: 'PayPal 주문 생성 실패',
	1050: 'Steam 주문 생성 실패',
	1051: '인증 검증 실패',
	1052: '인증 디코딩 실패',
	1053: '이메일 인증 코드가 전송됨',
	1054: '이메일 인증 코드 요청이 너무 빈번함',
	1055: '이메일 인증 코드가 올바르지 않음',
	1056: '해당 이메일 주소는 블랙리스트에 등록되어 있습니다.',
	1057: 'Discord가 구성되지 않았습니다',
	1058: 'Discord API 요청 실패',
	1059: 'Discord 뉴스 가져오기 실패',
	1060: 'Discord 공지사항',
	1061: '알리페이 QR코드 충전',
	1062: 'QR코드 충전 진행 중입니다. 잠시 기다려주세요...',
	1063: '닫기',
	1064: '홈으로 돌아가기',
	1065: '사용자 이름(포럼 계정 아님)',
	1066: '비밀번호',
	1067: '슈탱크',
	1068: '여기를 클릭하고 메세지를 보내주세요',
}

export default {
	...ko,

	1069: '로딩 중...',
	1070: '더 이상 없습니다',
	1071: '뉴스가 없습니다',

	1072: '순위',
	1073: '순위 데이터 없음',
}